import { composeIO } from 'react-compose-io'
import { historicoChamadoIO } from './HistoricoChamado.IO'
import HistoricoChamadoView from './HistoricoChamado.View'

export const HistoricoChamado = composeIO(HistoricoChamadoView, historicoChamadoIO)
